import React from 'react';

const Envelope = ({
  height = 48,
  width = 48,
  colorOne = '#B3B3B3',
  colorTwo = '#D6D6D6',
  colorThree = '#E6E6E6'
}) => (
  <svg className="svg-icon" height={height} width={width} viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
    <title>letter</title>
    <g>
      <path d="M46,41H2c-0.55228,0-1-0.44772-1-1V8c0-0.55228,0.44772-1,1-1h44c0.55228,0,1,0.44772,1,1v32 C47,40.55228,46.55228,41,46,41z" fill={colorOne} />
      <path d="M24,19c0.24121,0,0.48193,0.08691,0.67285,0.25977l22,20c0.30566,0.27832,0.40869,0.71582,0.25977,1.10059 C46.78369,40.74609,46.41309,41,46,41H2c-0.41309,0-0.78369-0.25391-0.93262-0.63965 c-0.14893-0.38477-0.0459-0.82227,0.25977-1.10059l22-20C23.51807,19.08691,23.75879,19,24,19z" fill={colorTwo} />
      <path d="M24,29c-0.24121,0-0.48193-0.08691-0.67285-0.25977l-22-20C1.02148,8.46191,0.91846,8.02441,1.06738,7.63965 C1.21631,7.25391,1.58691,7,2,7h44c0.41309,0,0.78369,0.25391,0.93262,0.63965c0.14893,0.38477,0.0459,0.82227-0.25977,1.10059 l-22,20C24.48193,28.91309,24.24121,29,24,29z" fill={colorThree} />
    </g>
  </svg>
);

export default Envelope;
